import React, { Fragment, useContext } from 'react';
import NavBar from '../../layouts/global/NavBar';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { AuthContext } from '../../contexts/AuthContext';
import { Redirect, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import axios from 'axios';
import SampleImage from '../../assets/images/sampleImg.png';

export default function LoginPage() {
  const history = useHistory();
  const { setState, autoLogout, state } = useContext(AuthContext);
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Enter a valid email')
      .required('Email is required'),
    password: Yup.string().required('Enter password'),
  });

  const loginUserAccount = async (values, actions) => {
    actions.setSubmitting(true);
    try {
      const response = await axios.post(
        'https://secret-ridge-31139.herokuapp.com/api/auth/login',
        values,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      actions.setSubmitting(false);

      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('userId', response.data.user.id);
      localStorage.setItem('userData', JSON.stringify(response.data.user));
      setState({
        isAuth: true,
        token: response.data.access_token,
        userId: response.data.user.id,
        userData: response.data.user,
      });
      const remainingMilliseconds = 60 * 60 * 1000;
      const expiryDate = new Date(new Date().getTime() + remainingMilliseconds);
      localStorage.setItem('expiryDate', expiryDate.toISOString());
      autoLogout(remainingMilliseconds);

      history.push('/dashboard');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
      {state.isAuth ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
      <main>
        <NavBar />
        <div
          className={
            'min-h-screen flex flex-col lg:flex-row pt-20 px-10 lg:px-24'
          }
        >
          <div className={'w-full lg:w-1/2'}>
            <div className={'w-full lg:w-2/3 mt-14'}>
              <div className={'mb-5'}>
                <h3 className={'text-3xl font-semibold text-gray-500'}>
                  Sign in here
                </h3>
              </div>
              <Formik
                initialValues={{
                  email: '',
                  password: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, formikHelpers) =>
                  loginUserAccount(values, formikHelpers)
                }
              >
                {(props) => (
                  <form>
                    <div className={'w-full py-2'}>
                      <label>Email Address</label>
                      <input
                        className={
                          'shadow w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'email'}
                        type={'email'}
                        value={props.values.email}
                        onChange={props.handleChange('email')}
                        onBlur={props.handleBlur('email')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.email && props.errors.email}
                      </p>
                    </div>
                    <div className={'w-full py-2'}>
                      <label>Password</label>
                      <input
                        className={
                          'shadow w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'password'}
                        type={'password'}
                        value={props.values.password}
                        onChange={props.handleChange('password')}
                        onBlur={props.handleBlur('password')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.password && props.errors.password}
                      </p>
                    </div>
                    <div
                      className={
                        'mt-5 flex flex-col justify-center items-center'
                      }
                    >
                      <button
                        type={'button'}
                        onClick={() => props.handleSubmit()}
                        className={
                          'bg-yellow-500 text-white border-2  border-yellow-500  rounded px-5 py-3 w-full mb-2'
                        }
                      >
                        {props.isSubmitting ? (
                          <LoadingSpinner color={'text-white'} />
                        ) : (
                          'Login'
                        )}
                      </button>
                      <div
                        className={
                          'w-full flex flex-row justify-between item-center'
                        }
                      >
                        <Link to={'/register'}>
                          <span className={'underline text-yellow-500 text-lg'}>
                            Create new account
                          </span>
                        </Link>
                        <Link to={'/login'}>
                          <span className={'underline text-yellow-500 text-lg'}>
                            Forgot password?
                          </span>
                        </Link>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
          <div
            className={
              'w-full mt-2 lg:mt-0 lg:w-1/2 flex justify-center items-center'
            }
          >
            <img src={SampleImage} alt={''} className={'w-full'} />
          </div>
        </div>
      </main>
    </Fragment>
  );
}
